import React, { useState, useMemo } from "react";
import {
  Input,
  Typography,
  Button,
  CircularLoader,
  Banner,
} from "@plum-xoxo/admin-dsm";
import { PLUM_ROUTES } from "../../constants/AppConstant";
import styled from "styled-components";
import { makeRequestAuth } from "../../utils/globals";
import _debounce from "lodash/debounce";
import ActionModal from "../Modals/ActionModal";
import { NotificationManager } from "react-notifications";
import profileService from "../../services/profileService";

const env = process.env.NODE_ENV || "production";
const config = require(`../../config/config.${env}.json`);

const GreyBackgroundDiv = styled.div`
  background-color: ${(props) => props.theme.palette.light.c100};
  border: 1px solid ${(props) => props.theme.palette.light.c300};
  border-radius: 8px;

  .img-box {
    width: 80%;
  }
`;

const ExploreMarketPlaceBlock = ({
  domain,
  rewardType,
  updateEmployeeDetails,
  fromSettings = false,
  toggleDomain,
  marketplaceError,
  setMarketplaceError,
  updatePlatformSettings
}) => {
  const storesUrl = `${config.storeFrontURL}`;

  const [subDomain, setSubDomain] = useState("");
  const [invalidUrl, setInvalidUrl] = useState(false);
  const [domainExist, setDomainExist] = useState(false);
  const [invalidMsg, setInvalidMsg] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [loader, setLoader] = useState(false);

  const toggleConfirmationModal = () => {
    setShowConfirmation((prevState) => !prevState);
  };

  const validateDomain = (value) => {
    value = value.trim()?.toLowerCase();
    setInvalidUrl(false);
    setDomainExist(false);
    setInvalidMsg("");
    if (!fromSettings) setMarketplaceError("");
    if (value.length === 0) {
      setLoader(false);
      return;
    }

    if (value.length > 25) {
      setLoader(false);
      return;
    }

    const checkIfRouteIsPresent = PLUM_ROUTES.findIndex(
      (route) => route === value
    );

    let regex1 = /^[a-z0-9](.*[a-z0-9])?$/;

    if (regex1.test(value) && checkIfRouteIsPresent === -1) {
      const query = "diy.query.check_subdomain_exists";

      const request_data = {
        query,
        tag: "diy",
        variables: {
          sub_domain: value,
        },
      };

      makeRequestAuth(
        request_data,
        (response) => {
          if (response?.data?.checkSubDomainExists?.success == 1) {
            if (
              response?.data?.checkSubDomainExists?.res?.sub_domain?.length > 0
            ) {
              setDomainExist(true);
              setInvalidMsg("The URL is not available.");
              setLoader(false);
            } else {
              setDomainExist(false);
              setLoader(false);
            }
          }
        },
        {},
        "/api/public/graph"
      );
    } else {
      setInvalidUrl(true);
      if (checkIfRouteIsPresent !== -1) {
        setInvalidMsg("The URL is not available.");
        setLoader(false);
        return;
      }
      setLoader(false);
      setInvalidMsg(
        "Enter a string starting and ending with a lowercase letter or digit."
      );
    }
  };

  const debouncedValidateName = useMemo(
    () => _debounce(validateDomain, 500),
    []
  );

  const saveDomain = () => {
    setLoader(true);
    const query = "diy.mutation.updatePlumDomain";
    const requestData = {
      query,
      tag: "diy",
      variables: {
        plum_domain: subDomain,
      },
    };

    makeRequestAuth(requestData, (response) => {
      if (response) {
        if (response?.data?.updatePlumDomain) {
          fetchAdminDetails();
          getPlatformSetting();
          if (!fromSettings) toggleConfirmationModal();
        } else {
          setLoader(false);
          NotificationManager.error("Something went wrong!");
        }
      }
    });
  };

  const fetchAdminDetails = () => {
    profileService
      .adminDetails({})
      .then((response) => {
        if (response && response.fetchUserDetails) {
          let userDetails = {
            timeZone: response.fetchUserDetails.timeZone || "",
            employee_first_name: response.fetchUserDetails.first_name || "",
            employee_last_name: response.fetchUserDetails.last_name || "",
            employee_email: response.fetchUserDetails.email || "",
            employee_primary_mobile: response.fetchUserDetails.contact || "",
            platform: response.fetchUserDetails.platform || "",
            domain: response.fetchUserDetails.domain || "",
          };
          userDetails.employee_full_name = userDetails.employee_first_name;
          userDetails.employee_full_name += userDetails.employee_first_name
            ? " " + userDetails.employee_last_name
            : userDetails.employee_last_name;
          updateEmployeeDetails(userDetails);
          setLoader(false);
        }
      })
      .catch(() => {
        setLoader(false);
        //this.setState({ loader: false });
      });
  };

  const getPlatformSetting = () => {
    setLoader(true)
    let fetchData = {
      urlPrefix: "",
    };
    profileService.getPlatformSetting(fetchData)
      .then((response) => {
        let res = (response && response.fetchPlatformSetting) || {};
        if (res.success == 1 && res.data) {
          updatePlatformSettings(res.data);
        }
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(()=>{
        setLoader(false)
      });
  };
  return (
    <>
      <div className="d-flex flex-column p-24 gap-24">
        <GreyBackgroundDiv className="d-flex gap-32">
          {domain && rewardType === 2 ? (
            <div className="p-16 w-100">
              <Typography.BodySmall component="div">
                Campaigns are customisable marketplaces that you can create and
                use for your various rewarding occasions.
                <br />
                <br />
                Our{" "}
                <a target="blank" href={storesUrl}>
                  {" "}
                  <Typography.BodySmall
                    color="primary"
                    shade="c02"
                    component="span"
                    className="cursor-pointer"
                  >
                    Global Redemption Marketplace
                  </Typography.BodySmall>{" "}
                </a>
                is set as the default campaign.
              </Typography.BodySmall>
            </div>
          ) : domain && rewardType === 3 ? (
            <div className="p-16 w-100">
              <Typography.BodySmall>
                Campaigns are customisable marketplaces that you can create and
                use for your various rewarding occasions.
              </Typography.BodySmall>
            </div>
          ) : (
            <>
              <div className="pt-24 pl-24 pb-12 img-box">
                <Typography.BodySmall>
                  Redemption marketplace is what your reward recipients will use
                  to redeem their rewards from a collection of gift cards,
                  merchandise experiences and more.
                </Typography.BodySmall>
                <a target="blank" href={storesUrl}>
                  <Typography.BodySmall
                    color="primary"
                    shade="c02"
                    className="cursor-pointer"
                  >
                    Explore Marketplace
                  </Typography.BodySmall>
                </a>
              </div>
              <div>
                <img
                  src="https://res.cloudinary.com/dyyjph6kx/image/upload/v1715678202/store/admin/Diy_marketplace_url.png"
                  width="100%"
                />
              </div>
            </>
          )}
        </GreyBackgroundDiv>
        {!domain && (
          <>
            <div id="domainForm">
              <Input
                value={subDomain}
                label="Marketplace URL"
                prefix={
                  <Typography color="dark" shade="c200" className="d-flex mb-0">
                    {storesUrl}
                  </Typography>
                }
                placeholder="mycompanyname"
                onChange={(e) => {
                  setLoader(true);
                  if (e.target.value.length > 25) return;
                  setSubDomain(e.target.value?.toLowerCase());
                  debouncedValidateName(e.target.value);
                }}
                error={invalidUrl || domainExist || marketplaceError}
                helperText={
                  <Typography component="span">
                    {marketplaceError ? (
                      marketplaceError
                    ) : invalidMsg ? (
                      invalidMsg
                    ) : subDomain.length > 0 && !loader ? (
                      <Typography color="green" shade="c300" component="span">
                        &#10003; The URL is available
                      </Typography>
                    ) : (
                      <Typography color="green" shade="c300" component="span">
                        &#8203;
                      </Typography>
                    )}
                  </Typography>
                }
                endIcon={loader ? <CircularLoader /> : null}
              />
            </div>
            {fromSettings && (
              <Banner
                iconName=""
                color="info"
                description={
                  <>
                    <Typography.LabelText component="span">
                      Note:{" "}
                    </Typography.LabelText>
                    <Typography.BodySmall className="mb-0" component="span">
                      Once you set the redemption marketplace URL, it cannot be
                      modified later on.
                    </Typography.BodySmall>
                  </>
                }
              />
            )}
            <Button
              className="ml-auto"
              disabled={
                subDomain.length === 0 || domainExist || invalidUrl || loader
              }
              onClick={fromSettings ? saveDomain : toggleConfirmationModal}
            >
              Save and Continue
            </Button>
          </>
        )}
      </div>
      {showConfirmation && (
        <ActionModal
          loading={loader}
          actionHandler={saveDomain}
          header={"Are you sure?"}
          cancelBtnText={"No, Cancel"}
          buttonText={"Yes, Proceed"}
          callbackMethod={toggleConfirmationModal}
          actionModalSubHeader={
            "Once you set the redemption marketplace URL, it cannot be modified later on."
          }
        />
      )}
    </>
  );
};
export default ExploreMarketPlaceBlock;
